"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _ExternalEventInfo = require("ExternalEventInfo");

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _temp;

var ExternalEventCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(ExternalEventCard, _Card$makeDefaultCard);

  function ExternalEventCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ExternalEventCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ExternalEventCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "event", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ExternalEventCard, [{
    key: "renderAdditionalTopItems",
    value: function renderAdditionalTopItems() {
      return _react.default.createElement("div", {
        className: "externalEventInfo date-container center"
      }, _react.default.createElement(_ExternalEventInfo.ExternalEventCardHeader, this.event));
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      return _react.default.createElement("div", null, _react.default.createElement(_ExternalEventInfo.ExternalEventCardBody, this.event));
    }
  }, {
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) return babelHelpers.get(babelHelpers.getPrototypeOf(ExternalEventCard.prototype), "renderBottomContent", this).call(this);
      return null;
    }
  }]);
  return ExternalEventCard;
}(_base.default.makeDefaultCardType('externalEvent', 'Event')), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "event", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = ExternalEventCard;